import { client } from "api";
import { User } from "features/auth/types/user";

export type GetCurrentUserRequest = string;

export type GetCurrentUserResponse = User;

export const getCurrentUser = async (token: string) =>
  client
    .get<GetCurrentUserResponse>(`/user/current`, {
      headers: { token },
    })
    .then((res) => res.data);
